<template>

<main class="lg:mb-[600px] relative z-10 bg-backgroundBody dark:bg-dark">
  <!--=====================================
     Page Header Details Section
  ======================================-->
  <section
    class="pt-32 max-md:pb-20 md:py-44 lg:pt-[200px] relative overflow-hidden"
  >
    <!-- Gradient Background Wrapper -->
    <div
      id="hero-gradient-wrapper"
      class="absolute w-full h-full top-0 left-0 -z-10 blur-[35px] md:blur-[60px] sm:scale-[0.1] bg-blend-multiply md:scale-75"
    >
      <img
        src="images/hero-gradient-background.png"
        alt="hero-gradient-background"
        id="hero-gradient"
        class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-[45%]"
      />
    </div>

    <!-- Hero Content Container -->
    <div class="container reveal-me">
      <div class="text-center">
        <!-- Badge Component -->
        <div class="rv-badge mb-4 lg:mb-10">
          <span class="rv-badge-text">Services Details</span>
        </div>

        <!-- Hero Title -->
        <h1 class="mb-5 lg:mb-8">Strategy</h1>

        <!-- Hero Description -->
        <p class="max-md:max-w-[650px]">
          Unlock the full potential of your business with a tailored strategy. We help brands navigate growth with insights and data-driven decision-making across key areas such as:<br><br>
        </p>
      </div>
    </div>
  </section>

  <!--=====================================
     Services Details Section
  ======================================-->
  <section class="pb-14 md:pb-16 lg:pb-[88px] xl:pb-[100px]">
    <div class="max-w-[1440px] mx-auto px-8 md:px-20">
      <div class="flex flex-col gap-8 lg:flex-row justify-start">
        <!-- Sticky Table of Contents -->
        <aside class="min-w-[275px] flex-1">
          <div class="sticky top-28">
            <div class="reveal-me">
              <h3 class="max-md:text-[40px] md:text-[32px]">Table of contents</h3>
              <ul class="mt-4 sm:mt-7 md:mt-10 [&>*:not(:last-child)]:mb-2 md:[&>*:not(:last-child)]:mb-5">
                <li>
                  <a
                    href="#service-overview"
                    class="text-xl normal-case font-normal leading-7 tracking-normal dark:text-dark-100 hover:font-medium hover:text-secondary dark:hover:text-backgroundBody transition-all lenis-scroll-to"
                  >
                    Service overview
                  </a>
                </li>
                <li>
                  <a
                    href="#our-service-includes"
                    class="text-xl normal-case font-normal leading-7 tracking-normal dark:text-dark-100 hover:font-medium hover:text-secondary dark:hover:text-backgroundBody transition-all lenis-scroll-to"
                  >
                    Our service includes
                  </a>
                </li>
                <li>
                  <a
                    href="#why-choose"
                    class="text-xl normal-case font-normal leading-7 tracking-normal dark:text-dark-100 hover:font-medium hover:text-secondary dark:hover:text-backgroundBody transition-all lenis-scroll-to"
                  >
                    Why Choose Us
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </aside>

        <!-- Main Content -->
        <article class="project-details-body">
          <div class="reveal-me">
            <h3 id="service-overview">Service overview</h3>
            <p>
              At Neue Media, we specialize in crafting tailored strategies that drive growth and innovation. We collaborate closely with you to decode market trends and leverage data-driven insights to propel your brand forward. From market positioning to digital outreach, every decision is backed by research and experience.
            </p>
          </div>
          <div class="reveal-me">
            <h3 id="our-service-includes">Our service includes</h3>
            <p>
              In-Depth Strategic Analysis: We conduct thorough research to understand your brand, target audience, and industry trends, ensuring your strategy is well-informed.<br><br>
              <strong>Brand Strategy:</strong> We refine your positioning, messaging, and competitive differentiation to create a strong market presence.<br><br>
              <strong>Go-to-Market Strategy:</strong> From launch planning to customer acquisition and scaling, we design actionable plans for success.<br><br>
              <strong>Digital Strategy:</strong> Leverage SEO, content, social media, and paid media to maximize your online impact.
            </p>
          </div>
          <div class="reveal-me">
            <h3 id="why-choose">Why Choose Us</h3>
            <p>
              Expertise and Innovation: Our team combines years of experience with cutting-edge data insights to deliver strategies that are both visionary and actionable.<br><br>
              Tailored Solutions: We understand that every business is unique, so we offer customized strategies that align perfectly with your brand and objectives.<br><br>
              Seamless Collaboration: We work closely with you throughout the process, ensuring your vision is realized with transparency and expertise.<br><br>
              End-to-End Service: From concept to execution, we handle every aspect of your strategy so you can focus on growing your business.<br><br>
              Speed and Efficiency: Our streamlined process ensures timely delivery of actionable strategies without compromising quality.<br><br>
              Results-Driven Approach: We focus on delivering measurable outcomes that drive engagement, conversion, and growth.
            </p>
          </div>
        </article>
      </div>
    </div>
  </section>

  <!--=====================================
     CTA Section
  ======================================-->
  <section
    class="pt-14 md:pt-16 lg:pt-[88px] xl:pt-[100px] pb-[70px] lg:pb-[140px] relative"
  >
    <div class="container">
      <!-- CTA Heading -->
      <h2
        class="text-center xl:text-[96px] font-normal xl:leading-[1.1] xl:tracking-[-2.88px]"
      >
        Got Questions?
        <span class="font-instrument sm:mt-10 italic block max-md:inline-block">
          We’ve Got Answers
        </span>
      </h2>

      <ul class="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-6 list-none">
        <!-- Primary CTA Button -->
        <li class="block md:inline-block w-[90%] mx-auto md:ml-auto md:mr-0 md:w-auto">
        </li>
        <!-- Secondary CTA Button -->
        <li class="block md:inline-block w-[90%] mx-auto md:mr-auto md:ml-0 md:w-auto">
          <router-link to="/contact" class="rv-button rv-button-primary block md:inline-block">
            <div class="rv-button-top contact-btn-lg">
              <span>Let's Connect</span>
            </div>
            <div class="rv-button-bottom contact-btn-lg">
              <span>Let's Connect</span>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
  </section>

</main>

<!--=====================================
   Footer Section
======================================-->
<FooterComponent/>
</template>

<script>
import FooterComponent from '@/components/FooterComponent.vue'

export default {
  name: 'StrategyPage',
  components: {
    FooterComponent,
  }
}
</script>